import { a as languages } from "../../core-8vQkh0Rd.js";
import { n as re } from "../../shared-BPLAFNn7.js";
//#region src/prism/languages/bsl.js
var charClass = ["\\wЀ-҄҇-ԯᴫᵸⷠ-ⷿꙀ-ꚟ︮︯"];
languages.oscript = languages.bsl = {
	"comment": /\/\/.*/,
	"string": /"(?:[^"]|"")*"(?!")|'(?:\\.|[^\n\\'])*'/g,
	"keyword": {
		pattern: re("(^|[^<0>])(?:пока|для|новый|прервать|попытка|исключение|вызватьисключение|иначе|конецпопытки|неопределено|функция|перем|возврат|конецфункции|если|иначеесли|процедура|конецпроцедуры|тогда|знач|экспорт|конецесли|из|каждого|истина|ложь|по|цикл|конеццикла|выполнить)(?![<0>])|\\b(?:break|do|each|else|elseif|enddo|endfunction|endif|endprocedure|endtry|except|execute|export|false|true|for|function|if|in|new|null|procedure|raise|return|then|to|try|undefined|val|var|while)\\b", charClass, "i"),
		lookbehind: true
	},
	"number": {
		pattern: re("(^(?=\\d)|[^<0>])(?:\\d+(?:\\.\\d*)?|\\.\\d+)(?:e[+-]?\\d+)?", charClass, "i"),
		lookbehind: true
	},
	"operator": {
		pattern: re("[<>*/+-]=?|[%=]|\\b(?:and|not|or)\\b|(^|[^<0>])(?:и|или|не)(?![\\w<0>])", charClass, "i"),
		lookbehind: true
	},
	"punctuation": /\(\.|\.\)|[()[\].,:;]/,
	"directive": {
		pattern: /^([ 	]*)[&#].*/gm,
		lookbehind: true,
		alias: "important"
	}
};
//#endregion

//# sourceMappingURL=bsl.js.map